import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireAuth } from '@angular/fire/auth';
import { trackingModel } from 'src/app/Models/trackingModel';


@Injectable({
  providedIn: 'root'
})
export class FactoryService  {
private data=[];
private nbCompo:number[]=[]
dateSante= new BehaviorSubject("")
openView0Chat:boolean=false
openView1Chat:boolean=false
openView2Chat:boolean=false
openView3Chat:boolean=false
lancerPrime= new BehaviorSubject("")
sendObject = new BehaviorSubject(null);
user:string
constructor(
    private db: AngularFireDatabase,
    private afAuth:AngularFireAuth,
) {
    this.afAuth.authState.subscribe(user =>{
      if(user)
        this.user=user.uid
    })

  }

async seTtracking(date:string,level:string,calling:boolean,compagnie:string,observation:string="",produit:string="",autre:string=""){
   
  var subs=  this.db.list(`tracking/${compagnie}`,ref => ref.orderByChild("uid").equalTo(this.user)).snapshotChanges()
    .subscribe(
      (actions) => {
        let List = []   
     
        // e.payload.exportVal().produit===produit &&
            List=actions.filter(e =>  e.payload.exportVal().level===level && e.payload.exportVal().produit===produit &&
            !e.payload.exportVal().calling &&
            (e.payload.exportVal().date_create).split('T')[0] == (new Date().toISOString()).split('T')[0]
            )
            .map(c => {
                 return {
                        key: c.payload.key,
                        // produit:c.payload.exportVal().produit, 
                        // calling:c.payload.exportVal().calling,
                        // date:(""+c.payload.exportVal().date_create).split('T')[0]
                    }})   
                
            if (List.length>0) {
              this.db.object(`tracking/${compagnie}/${List[0].key}`).update({
                level:level,
                calling:calling,
                produit:produit,
                date_create:new Date().toISOString(),
                code_compagine:compagnie
              })
              subs.unsubscribe()
            }
            else if (produit){
                this.db.list(`tracking/${compagnie}`).push(new trackingModel(
                    this.user,date,level,calling,compagnie,
                    observation,produit,autre
                ))
                subs.unsubscribe()
            }
          }      
    )
  
   
   
  
}

async seTtracking0(date:string,level:string,calling:boolean,compagnie:string,observation:string="",produit:string="",autre:string=""){
    this.db.list(`tracking/${compagnie}`).push(new trackingModel(
        this.user,
        date,
        level,
        calling,
        compagnie,
        observation,
        produit,
        autre
    ))

       
  }
setnbComponent(idcomp:number){
   if (this.nbCompo.filter(e => e==idcomp).length>0) return
    
    this.nbCompo.push(idcomp)
}
getnbComponent(){
   return this.nbCompo
}
    setData(id,data){
        this.data[id]=data
    }
    
     getData(id){
        return this.data[id];
    }


}


